// /**
//  * Validates the headers of the uploaded Excel file to ensure all required fields are present.
//  *
//  * @param {Array} headers - The array of column headers extracted from the Excel file.
//  * @returns {Array|null} - Returns an array of missing fields if validation fails, otherwise returns null.
//  */
// const ValidateExcelFile = (headers) => {
//   // Define the fixed required fields
//   const requiredFields = [
//     "MFR PART NUMBER", // Example required field
//     "MFR", // Example required field
//     //   'PRODUCT DESCRIPTION', // Example required field
//     //   'Company Cost' // Example required field
//   ];

//   // Find missing fields
//   const missingFields = requiredFields.filter(
//     (field) => !headers.includes(field)
//   );

//   // Return missing fields or null if validation passes
//   return missingFields.length === 0 ? null : missingFields;
// };

// export default ValidateExcelFile;

/**
 * Validates that all required columns are present in the uploaded Excel file.
 *
 * @param {Array} headers - Column headers from row 1 of the sheet.
 * @returns {Array|null} - Missing field names, or null if all present.
 */
const ValidateExcelFile = (headers) => {
  const requiredFields = [
    "PRODUCT TYPE",
    "SKU",
    "VENDOR",
  ];

  const missingFields = requiredFields.filter(
    (field) => !headers.includes(field)
  );

  return missingFields.length === 0 ? null : missingFields;
};

export default ValidateExcelFile;